/**
 * Mockup v3 P5 (Diseño), owner 2026-10-19: the strings of "Borrar perfil" and its confirmation.
 * Spread into `es` by `es.ts`. The server writes its own refusals (the system default, a scope
 * the person may only read), so only the fallback lives here.
 */
export const esDesignDelete = {
  "design.delete.action": "Borrar perfil",
  "design.delete.title": "¿Borrar este perfil de diseño?",
  "design.delete.body":
    "Deja de aparecer en la lista y ningún ámbito lo usará en los mockups nuevos. Los mockups que ya lo usan conservan su diseño.",
  "design.delete.confirm": "Borrar perfil",
  "design.delete.cancel": "Cancelar",
  "design.delete.failed": "No se pudo borrar el perfil. Inténtalo de nuevo.",
} as const;

/**
 * Audit P5 (mockup v3 ~1715-1771): a profile the person may read but not edit (the system default, or a
 * profile of a scope they do not manage) in the full editor, read-only, with "Duplicar y editar".
 */
export const esDesignReadOnly = {
  "design.readOnly.title": "Ver perfil",
  "design.readOnly.system": "Es el diseño que se usa cuando un ámbito no tiene perfil activo.",
  "design.readOnly.team": "Solo quien administra el ámbito de este perfil puede modificarlo.",
  "design.readOnly.duplicateHint": "Duplícalo para adaptarlo a tu marca.",
  "design.readOnly.duplicate": "Duplicar y editar",
  "design.readOnly.noLogoSystem": "El diseño del sistema no lleva logo.",
  "design.readOnly.noLogo": "Este perfil no tiene logo.",
} as const;
